export default __webpack_public_path__ + "static/logo-h-990e984ac92fa40856623ce13cfac46a.svg";